import moment from 'moment-timezone';

/**
 * Render a stored instant as a wall-clock time.
 *
 * An entry records WHEN SOMEONE WORKED, so the honest clock to show is the one
 * that was on their wall — not the viewer's and not the tenant's. Entries carry
 * `localZone` for exactly this, and passing it keeps the time consistent with
 * the `localDate` the entry is grouped under. Without it a 7:26 PM Oct 8 entry
 * from Pacific/Pago_Pago rendered as "11:56 AM" under an Oct 8 heading on an
 * IST tenant — a clock and a date from two different days.
 *
 * Falls back to the tenant zone for rows written before `localZone` existed.
 */
const TimestampConverter = (timestamp, zone) => {
    const targetZone =
        (zone && moment.tz.zone(zone) && zone) || global.config.getTimeZone();
    return moment.utc(timestamp).tz(targetZone).format('hh:mm A');
};

export default TimestampConverter;
